import React, { useEffect, useState } from "react";

/**
 * Fixed gradient progress bar at the top of the page.
 * Scales horizontally based on scroll percentage.
 */
const ScrollProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const p = height > 0 ? (scrolled / height) * 100 : 0;
      setProgress(Math.max(0, Math.min(100, p)));
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[80] h-[3px] pointer-events-none"
      aria-hidden
    >
      <div
        data-testid="scroll-progress-bar"
        className="h-full bg-gradient-to-r from-pink-500 via-orange-500 to-purple-500 transition-[width] duration-100 ease-out shadow-[0_0_16px_rgba(236,72,153,0.6)]"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default ScrollProgress;
